import React from 'react';
import './MobileDashboardSkeleton.css';

/**
 * First-load skeleton for the mobile dashboard — native-app parity: the RN
 * DashboardSkeleton's pulse (0.5 ↔ 0.9) plus a travelling white sweep on every
 * placeholder, laid out to mirror the real screen (serif title, chip rail,
 * compare track, controls, section captions, stacked StatCards).
 */
const Box = ({ w, h, r = 8, style }) => (
  <div className="msk-box" style={{ width: w, height: h, borderRadius: r, ...style }} />
);

const StatCardSkeleton = ({ withSparkline = false, subW = '60%' }) => (
  <div className="msk-card">
    <div className="msk-card-top">
      <div style={{ flex: 1, minWidth: 0 }}>
        <Box w={120} h={11} style={{ marginBottom: 12 }} />
        <Box w="80%" h={38} r={10} />
      </div>
      <div className="msk-card-right">
        <Box w={72} h={22} r={999} />
        <Box w={90} h={10} />
      </div>
    </div>
    <Box w={subW} h={12} style={{ marginTop: 12 }} />
    {withSparkline && <Box w="100%" h={48} r={6} style={{ marginTop: 14 }} />}
  </div>
);

const SectionLabel = ({ titleW = 170, metaW = 90 }) => (
  <div className="msk-section-row">
    <Box w={titleW} h={12} />
    <Box w={metaW} h={12} />
  </div>
);

export function MobileDashboardSkeleton() {
  return (
    <div className="msk-canvas">
      {/* Header: serif title + briefing button slot, subtitle */}
      <div className="msk-header">
        <div className="msk-title-row">
          <Box w={180} h={30} />
          <Box w={92} h={30} r={999} />
        </div>
        <Box w={210} h={12} style={{ marginTop: 8 }} />

        {/* Quick-date chip rail */}
        <div className="msk-chip-row">
          <Box w={92} h={32} r={999} />
          <Box w={110} h={32} r={999} />
          <Box w={110} h={32} r={999} />
          <Box w={110} h={32} r={999} />
        </div>

        {/* Compare caption + segmented track */}
        <Box w={90} h={11} style={{ marginTop: 12 }} />
        <Box w="100%" h={38} r={10} style={{ marginTop: 8 }} />

        {/* Controls row */}
        <div className="msk-controls-row">
          <Box w="52%" h={36} r={999} />
          <Box w={88} h={36} r={999} />
          <Box w={36} h={36} r={999} />
        </div>
      </div>

      <SectionLabel titleW={170} metaW={80} />
      <StatCardSkeleton withSparkline />
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />

      <SectionLabel titleW={150} metaW={120} />
      <StatCardSkeleton />
      <StatCardSkeleton />
    </div>
  );
}

export default MobileDashboardSkeleton;
